import api from './api';

// Fallback data khi chưa đăng nhập hoặc đang kết nối API
export const FALLBACK_DASHBOARD_DATA = {
  updatedAt: new Date().toISOString(),
  reportDate: new Date().toLocaleDateString('vi-VN', { day: '2-digit', month: '2-digit', year: 'numeric' }),
  systemStatus: {
    agentStatus: 'ONLINE',
    activeAgentsCount: 12,
    systemHealth: '99.98%',
    syncLatency: '24ms'
  },
  kpis: [
    {
      key: 'today_revenue',
      title: 'Doanh thu hôm nay',
      value: '1.45',
      unit: 'Tỷ VNĐ',
      badge: '+12.4%',
      badgeType: 'success',
      subtitle: '107% KPI ngày (Mục tiêu 1.35 Tỷ)',
      icon: 'dollar'
    },
    {
      key: 'month_revenue',
      title: 'Doanh số tháng lũy kế',
      value: '38.6',
      unit: 'Tỷ VNĐ',
      badge: '96.5% KPI',
      badgeType: 'warning',
      subtitle: 'Kế hoạch tháng: 40.0 Tỷ',
      icon: 'trending'
    },
    {
      key: 'order_fulfillment',
      title: 'Tỷ lệ lấp đầy đơn hàng',
      value: '98.4%',
      unit: '',
      badge: '+1.2%',
      badgeType: 'success',
      subtitle: '2,180 / 2,215 đơn thành công',
      icon: 'truck'
    },
    {
      key: 'active_pharmacies',
      title: 'Nhà thuốc hoạt động',
      value: '2,410',
      unit: 'Điểm bán',
      badge: '+18 điểm',
      badgeType: 'success',
      subtitle: 'Kênh Chothuoc247 & OTC',
      icon: 'store'
    },
    {
      key: 'ai_savings',
      title: 'Chi phí tiết kiệm từ AI',
      value: '185',
      unit: 'Triệu VNĐ',
      badge: '12 Agents',
      badgeType: 'accent',
      subtitle: 'Tự động hóa 4,800 thao tác/tuần',
      icon: 'cpu'
    },
    {
      key: 'hr_pipeline',
      title: 'Hồ sơ tuyển dụng',
      value: '24',
      unit: 'Hồ sơ',
      badge: '5 mới',
      badgeType: 'danger',
      subtitle: '8 vị trí đang mở tuyển',
      icon: 'users'
    }
  ],
  revenue7Days: {
    categories: ['04/09', '05/09', '06/09', '07/09', '08/09', '09/09', '10/09'],
    actual: [1.20, 1.28, 1.15, 1.42, 1.38, 1.52, 1.45],
    target: [1.35, 1.35, 1.35, 1.35, 1.35, 1.35, 1.35],
    chothuoc247: [0.85, 0.92, 0.78, 1.10, 1.05, 1.25, 1.18]
  },
  projects: [
    {
      id: 'PRJ-TTP',
      code: 'TTP',
      name: 'Thế Thảo Pharma — Mở rộng Kênh Phân Phối OTC',
      lead: 'Ban Điều Hành',
      progress: 78,
      status: 'ON_TRACK',
      statusLabel: 'Đúng tiến độ',
      color: '#10b981',
      budget: '12.5 Tỷ',
      headcount: 45,
      nextMilestone: 'Khai trương tổng kho Dược miền Trung (15/10)'
    },
    {
      id: 'PRJ-TOP',
      code: 'TOP',
      name: 'The One Pharma — Nghiên cứu & Sản xuất OEM/ODM',
      lead: 'Khối R&D',
      progress: 64,
      status: 'WARNING',
      statusLabel: 'Cần lưu ý kiểm định',
      color: '#3b82f6',
      budget: '8.2 Tỷ',
      headcount: 28,
      nextMilestone: 'Hoàn thiện hồ sơ công bố 2 dòng TPCN mới'
    },
    {
      id: 'PRJ-TTCE',
      code: 'TTCE',
      name: 'Tủ Thuốc Cho Em — CSR Vì Sức Khỏe Học Đường',
      lead: 'Ban CSR Thế Thảo',
      progress: 85,
      status: 'EXCELLENT',
      statusLabel: 'Tiến độ vượt kỳ vọng',
      color: '#f59e0b',
      budget: '1.8 Tỷ',
      headcount: 12,
      nextMilestone: 'Trao đợt 4 tại 35 điểm trường tỉnh Cao Bằng'
    },
    {
      id: 'PRJ-TECHPHA',
      code: 'TECHPHA',
      name: 'Techmedcom Platform — Nền tảng Số Chothuoc247.vn',
      lead: 'Khối Công Nghệ',
      progress: 42,
      status: 'SPRINTING',
      statusLabel: 'Đang tăng tốc Sprint',
      color: '#ef4444',
      budget: '3.6 Tỷ',
      headcount: 16,
      nextMilestone: 'Tích hợp AI Recommender Báo giá thời gian thực'
    }
  ],
  pendingApprovals: [
    {
      id: 'APP-01',
      title: 'Tăng ngân sách tuyển dụng 5 Nhân viên Kinh doanh OTC miền Tây',
      department: 'Nhân sự & Kinh doanh',
      requestedBy: 'Trưởng phòng Tuyển dụng',
      amount: '45.000.000 đ',
      priority: 'HIGH',
      priorityLabel: 'Ưu tiên cao',
      submittedTime: '2 giờ trước',
      status: 'pending'
    },
    {
      id: 'APP-02',
      title: 'Ký kết hợp đồng phân phối độc quyền dòng Omega-3 Nauy tại Đà Nẵng',
      department: 'Phát triển Kinh doanh',
      requestedBy: 'Giám đốc Vùng',
      amount: '320.000.000 đ',
      priority: 'URGENT',
      priorityLabel: 'Khẩn cấp',
      submittedTime: '4 giờ trước',
      status: 'pending'
    },
    {
      id: 'APP-03',
      title: 'Phê duyệt đợt tài trợ 35 Tủ thuốc sơ cứu trường học vùng cao',
      department: 'Ban Dự Án CSR',
      requestedBy: 'Điều phối viên TTCE',
      amount: '85.000.000 đ',
      priority: 'MEDIUM',
      priorityLabel: 'Bình thường',
      submittedTime: '1 ngày trước',
      status: 'pending'
    },
    {
      id: 'APP-04',
      title: 'Nâng cấp bảo mật SSL và máy chủ dữ liệu nhà thuốc đối tác',
      department: 'Bộ phận IT & Techmed',
      requestedBy: 'Kỹ sư Trưởng',
      amount: '62.500.000 đ',
      priority: 'HIGH',
      priorityLabel: 'Ưu tiên cao',
      submittedTime: '1 ngày trước',
      status: 'pending'
    }
  ],
  aiAgents: [
    {
      id: 'agent-recruiter',
      name: 'AI Recruiter & CV Screener',
      role: 'Tự động sàng lọc hồ sơ ứng viên theo JD, xếp hạng năng lực',
      status: 'active',
      efficiency: '99.4%',
      tasksProcessed: '38 hồ sơ',
      icon: 'user-check'
    },
    {
      id: 'agent-pricing',
      name: 'Chothuoc247 Dynamic Pricing Bot',
      role: 'Phân tích giá thị trường dược & tối ưu chiết khấu nhà thuốc',
      status: 'active',
      efficiency: '98.9%',
      tasksProcessed: '1,420 báo giá/ngày',
      icon: 'tag'
    },
    {
      id: 'agent-support',
      name: 'OTC Customer Care Agent',
      role: 'Tư vấn thông tin sản phẩm và giải đáp đơn hàng 24/7',
      status: 'active',
      efficiency: '99.8%',
      tasksProcessed: '340 cuộc thoại & chat',
      icon: 'message-circle'
    },
    {
      id: 'agent-finance',
      name: 'Financial Audit & Risk Monitor',
      role: 'Tự động đối soát công nợ đại lý và cảnh báo hóa đơn chậm',
      status: 'active',
      efficiency: '97.6%',
      tasksProcessed: '92% hóa đơn tự động',
      icon: 'shield-alert'
    }
  ],
  risks: [
    {
      id: 'RSK-01',
      level: 'HIGH',
      levelLabel: 'Cảnh báo cao',
      title: 'Tồn kho 3 mã hàng chủ lực đang tiệm cận mức an toàn',
      detail: 'Kho miền Trung chỉ còn đủ cơ số phục vụ trong 4 ngày, cần điều chuyển gấp từ kho tổng.',
      affectedDepartment: 'Cung ứng & Kho vận'
    },
    {
      id: 'RSK-02',
      level: 'MEDIUM',
      levelLabel: 'Cần theo dõi',
      title: 'SLA phỏng vấn ứng viên tuyển dụng Sales OTC vượt 48h',
      detail: 'Hiện có 5 hồ sơ mới chờ duyệt, cần phân bổ lịch phỏng vấn nhanh để tránh mất ứng viên tốt.',
      affectedDepartment: 'Nhân sự'
    },
    {
      id: 'RSK-03',
      level: 'LOW',
      levelLabel: 'Nhắc nhở',
      title: 'Gia hạn chứng chỉ GMP cho xưởng đóng gói The One Pharma',
      detail: 'Hạn kiểm tra định kỳ vào cuối quý 4, hồ sơ hiện đã đạt 70%.',
      affectedDepartment: 'Pháp chế & R&D'
    }
  ]
};

export const dashboardService = {
  /**
   * Lấy dữ liệu tổng hợp Dashboard
   */
  getSummary: async () => {
    try {
      const res = await api.get('/dashboard/summary');
      return res.data || res;
    } catch (err) {
      console.warn('Lỗi gọi API /dashboard/summary, dùng fallback data:', err.message);
      return FALLBACK_DASHBOARD_DATA;
    }
  },

  /**
   * Lấy dữ liệu dashboard Ban Trợ Lý (Trợ Lý Công Nghệ)
   */
  getTroLyDashboard: async () => {
    try {
      const res = await api.get('/dashboard/departments/tro-ly');
      return res.data || res;
    } catch (err) {
      console.warn('Lỗi gọi API /dashboard/departments/tro-ly:', err.message);
      return null;
    }
  },

  /**
   * Phê duyệt 1-click mục đề xuất
   */
  approveItem: async (itemId, action = 'approve', note = '') => {
    try {
      const res = await api.post('/dashboard/approve-item', { itemId, action, note });
      return res.data || res;
    } catch (err) {
      console.warn('Lỗi gọi API approve-item, mô phỏng phản hồi:', err.message);
      return {
        success: true,
        itemId,
        action,
        approvedAt: new Date().toISOString(),
        message: action === 'approve' ? `Đã phê duyệt [${itemId}]` : `Đã từ chối [${itemId}]`
      };
    }
  }
};
